import axios from 'axios';
import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';


import Vue from 'vue'

const getDefaultStateForProductMedias= () => {
    return {
        media_id:'',
        is_updated:null,
        is_deleted:null,
    }
}

// state
const state = getDefaultStateForProductMedias()

// getters
const getters = {

}

// mutations
const mutations = {
    RESET_STATE_FOR_PRODUCT_MEDIAS (state) {
        Object.assign(state, getDefaultStateForProductMedias())
    },
    SET_IS_UPDATED(state, data){
        state.is_updated = data
    },
    SET_IS_DELETED(state, data){
        state.is_deleted = data
    },
}

// actions
const actions = {
    resetState({ commit }, payload) {
        commit("RESET_STATE_FOR_PRODUCT_MEDIAS")
    },
    async update({ commit, dispatch }, data) {
      await axios
          .post(apiRoutes['PRODUCT_MEDIA_UPDATE_PRODUCT_ID'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
                Vue.notify({
                      group: 'notify',
                      type: 'success',
                      text: "Product Media Uploaded",
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })

                  console.log("A")
                  commit("SET_IS_UPDATED", 1)

                }
            else
            {
                let errors = response.data.data.errors

                if(Array.isArray(errors))
                {
                  let msg = errors.join("\n")

                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                }


            }

          })
          .catch((error) => {
              // alert(error)
              // console.log(error.response)

              if (error.response) {
                  //alert(error.response.data.message)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  //console.log("Problem submitting New Post", error);
                  alert("Problem Creating Bank Accounts")
              }
          });
    },
    async delete({ commit, dispatch }, data) {
        await axios
            .post(apiRoutes['PRODUCT_MEDIA_DELETE'], data, authHeader())
            .then(function (response) {
              if(response.data.code == 1)
              {
                  let name  = response.data.data.name
                  Vue.notify({
                      group: 'notify',
                      type: 'success',
                      text: "Media " + name + " has been deleted",
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
                 commit("SET_IS_DELETED", 1)
  
              }
              else
              {
                  let errors = response.data.data.errors
  
                  if(Array.isArray(errors))
                  {
                    console.log(errors)
                    let msg = errors.join("\n")
  
                    Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
                  }
  
  
              }
  
            })
            .catch((error) => {
                // alert(error)
                // console.log(error.response)
  
                if (error.response) {
                    //alert(error.response.data.message)
                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: error.response.data.message,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                }
                else
                {
                    //console.log("Problem submitting New Post", error);
                    alert("Application exception")
                }
            });
      }
}

export {
    state,
    getters,
    actions,
    mutations
}
